import { PAGE_FETCHED } from "../types";

export default function page(state = { activeClass: false}, action = {}) {
  switch (action.type) {
    case PAGE_FETCHED:
      return { ...state, ...action.page };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/page.js